(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-whatsapp-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
    const blocks = document.querySelectorAll('[data-product-whatsapp-enquiry]');

    blocks.forEach((block) => {
      if (block.dataset.whatsappReady === 'true') return;
      block.dataset.whatsappReady = 'true';

      const link = block.querySelector('[data-whatsapp-link]');
      const customerMessageInput = block.querySelector('[data-whatsapp-customer-message]');
      const variantsData = block.parentElement?.querySelector(
        '[data-product-variants-for-whatsapp]'
      );

      if (!link) return;

      link.addEventListener('click', () => {
        const number = link.dataset.whatsappNumber;
        const customTemplate = link.dataset.messageTemplate;
        const productTitle = link.dataset.productTitle;
        const customerMessage = customerMessageInput?.value.trim() || '';
        const customerMessageLabel =
          link.dataset.customerMessageLabel || 'Customer Message';
        const currentUrl = window.location.href;
        const productForm =
          block.closest('.shopify-section')?.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
        const variantInput = productForm?.querySelector('[name="id"]');
        const variantId = variantInput?.value;
        let selectedVariant;

        if (variantsData && variantId) {
          try {
            const variants = JSON.parse(variantsData.textContent);
            selectedVariant = variants.find(
              (variant) => String(variant.id) === String(variantId)
            );
          } catch (error) {
            selectedVariant = undefined;
          }
        }

        let message = customTemplate;
        const formattedPrice = selectedVariant
          ? new Intl.NumberFormat(document.documentElement.lang || 'en-ZA', {
              style: 'currency',
              currency: window.Shopify?.currency?.active || 'ZAR'
            }).format(selectedVariant.price / 100)
          : '';

        if (message) {
          message = message
            .replaceAll('[product_title]', productTitle)
            .replaceAll('[product_url]', currentUrl)
            .replaceAll('[variant_title]', selectedVariant?.title || '')
            .replaceAll('[sku]', selectedVariant?.sku || '')
            .replaceAll('[price]', formattedPrice)
            .replaceAll('[customer_message]', customerMessage);
        } else {
          message = `PRODUCT ADVICE\n\nHi Smart Spaces, I’d like advice on:\n${productTitle}`;

          if (selectedVariant?.title && selectedVariant.title !== 'Default Title') {
            message += `\nVariant: ${selectedVariant.title}`;
          }

          if (selectedVariant?.sku) {
            message += `\nSKU: ${selectedVariant.sku}`;
          }

          if (formattedPrice) {
            message += `\nPrice: ${formattedPrice}`;
          }

          message += `\n${currentUrl}`;
        }

        if (customerMessage && !customTemplate?.includes('[customer_message]')) {
          message += `\n\n${customerMessageLabel}\n${customerMessage}`;
        }

        link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
